/** @type {HTMLDivElement} */
const header = document.querySelector("header.fixed");

function setHeaderHeightVar() {
  if (!header) return;
  const height = header.offsetHeight;
  document.body.style.setProperty("--header-height", `${height}px`);
}
console.log("Header init");
setHeaderHeightVar();
window.addEventListener("resize", setHeaderHeightVar);
